export default "{\n    \"facilityCountLabel_one\": \"{{count}} facility\",\n    \"facilityCountLabel_other\": \"{{count}} facilities\"\n}\n"